import React from 'react';
import PropTypes from 'prop-types';
import TitleRow from './TitleRow';
import Table from '../../common/components/table/agGrid/Table';
import { AgentMovementDashboard } from './AgentMovementDashboard';
import { DownloadResultsModal } from '../../common/components/DownloadResultsModal';

export const AgentMovementResults = ({titleRowProps, tableProps, chartProps}) => {
    return (<>
        <TitleRow
            {...titleRowProps}
            columns={tableProps?.columns}
            setColumns={tableProps?.setColumns}
        />
        <AgentMovementDashboard chartProps={chartProps} />
        <div className='agent-movement-table'>
            <Table {...tableProps}/>
        </div>
        <DownloadResultsModal />
    </>);
}

AgentMovementResults.propTypes = {
    titleRowProps: PropTypes.object,
    tableProps: PropTypes.object,
    chartProps: PropTypes.object,
};

export default AgentMovementResults;
